// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iazAppPkWNwg5UHu5Ye4{flex-direction:column;gap:24px;padding-top:48px;display:flex}.Zt9wR1ktwNQ8b0GzvX5w{width:140px}.P6BzkNrcC5keiJ4tR3if{margin:0}.Juq4_VFLYwogRqTrcLmh{align-items:center;gap:8px;margin-top:8px;display:flex}.rKGhxxbO_N8GwLH_ynjQ{margin-bottom:-4px!important}.hPvG9wSL8eIj6fuPLtIP{resize:none;min-height:62px;font-size:13px;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customizeBlock": `iazAppPkWNwg5UHu5Ye4`,
	"primaryColorBlock": `Zt9wR1ktwNQ8b0GzvX5w`,
	"widgetPositionLabel": `P6BzkNrcC5keiJ4tR3if`,
	"widgetPositionRow": `Juq4_VFLYwogRqTrcLmh`,
	"complianceTextLabel": `rKGhxxbO_N8GwLH_ynjQ`,
	"complianceTextarea": `hPvG9wSL8eIj6fuPLtIP`
};
export default ___CSS_LOADER_EXPORT___;
